import { render, staticRenderFns } from "./CustomerSignature.vue?vue&type=template&id=51277652"
import script from "./CustomerSignature.vue?vue&type=script&lang=ts"
export * from "./CustomerSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports